import { PendingAddress } from './shared/pendingData'
import { RootState } from './store'

// Re-export all feature selectors
export * from './features/booking/selectors'
export * from './features/cart/cartSlice'
export * from './features/products/selectors'
export * from './features/services/selectors'
export * from './shared/recently-viewed'

// Privacy selectors
export const selectPrivacySettings = (state: RootState) => state.privacy
export const selectCookieConsent = (state: RootState) => state.privacy.cookieConsent
export const selectAnalyticsConsent = (state: RootState) => state.privacy.cookieConsent.analytics

// Content selectors
export const selectArticles = (state: RootState) => state.articles.items
export const selectSelectedArticle = (state: RootState) => state.articles.selectedArticle

export const selectProducts = (state: RootState) => state.products.items
export const selectSelectedProduct = (state: RootState) => state.products.selectedProduct

export const selectServices = (state: RootState) => state.services.items
export const selectSelectedService = (state: RootState) => state.services.selectedService

// Pending data selectors
export const selectPendingAddresses = (state: RootState): PendingAddress[] =>
  state.pendingData?.pendingAddresses || []
